import { createReducer, on } from '@ngrx/store';
import * as BusinessPlantDetailActions from './business-plant-detail.actions';
import { BusinessPlantDetailState } from './business-plant-detail.models';

export const initialState: BusinessPlantDetailState = {
  details: {},
  loading: false,
  error: null,
};

export const businessPlantDetailReducer = createReducer(
  initialState,
  on(BusinessPlantDetailActions.loadBusinessPlantDetail, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(BusinessPlantDetailActions.loadBusinessPlantDetailSuccess, (state, { BusinessPlanGuid, detail }) => ({
    ...state,
    loading: false,
    error: null,
    details: { ...state.details, [BusinessPlanGuid]: detail },
  })),
  on(BusinessPlantDetailActions.loadBusinessPlantDetailFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(BusinessPlantDetailActions.resetBusinessPlantDetail, () => initialState),
);
